module.exports = __webpack_public_path__ + "img/2.1e049dc4.png";